import React, { useCallback, useRef, useState } from "react";
import { useInView, useReducedMotion } from "framer-motion";

const FREEZE_AT = 97;

export function useComparisonFrame() {
  const [pos, setPos] = useState(50);
  const frameRef = useRef<HTMLDivElement>(null);
  const dragging = useRef(false);
  const scanStarted = useInView(frameRef, { once: true, amount: 0.5 });
  const reduce = useReducedMotion() ?? false;
  const frozen = pos >= FREEZE_AT;

  const setFromClientX = useCallback((x: number) => {
    const el = frameRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setPos(Math.min(100, Math.max(0, ((x - rect.left) / rect.width) * 100)));
  }, []);

  const onKeyDown = (e: React.KeyboardEvent) => {
    const step = e.shiftKey ? 10 : 2;
    if (e.key === "ArrowLeft") setPos((p) => Math.max(0, p - step));
    else if (e.key === "ArrowRight") setPos((p) => Math.min(100, p + step));
    else if (e.key === "Home") setPos(0);
    else if (e.key === "End") setPos(100);
    else return;
    e.preventDefault();
  };

  const pointerHandlers = {
    onPointerDown: (e: React.PointerEvent<HTMLDivElement>) => {
      dragging.current = true;
      e.currentTarget.setPointerCapture(e.pointerId);
      setFromClientX(e.clientX);
    },
    onPointerMove: (e: React.PointerEvent<HTMLDivElement>) => {
      if (dragging.current) setFromClientX(e.clientX);
    },
    onPointerUp: () => {
      dragging.current = false;
    },
    onPointerCancel: () => {
      dragging.current = false;
    },
  };

  return { pos, frameRef, frozen, scanStarted, reduce, onKeyDown, pointerHandlers };
}
